/*jslint sloppy: true*/
/*global getResponsiveBreakpoint: true, isElementInViewport: true, jQuery: true */

var Northstar = Northstar || {};

(function ($, window, document) {
  'use strict';

  // ---------------------------------------------------------------------------
  // Collections
  Northstar.collections = {
    attach: function () {
      //console.log('Northstar.collections loaded');

      // View mode switcher
      $('.collections-util--viewmode a').on('click', Northstar.collections.viewMode);

      // Duplicate collection description to image container for rollover
      $('.collection-card').each(function () {
        var desc = $('.collection-desc', this).clone();
        $('.collection-image', this).append(desc);
      });

      // Share modal submission via ajax with confirmation
      //$('#shareCollectionModal').on('show.bs.modal', function (e) {
      //  Northstar.forms.reset($('form', this)[0]);
      //  $('#shareCollectionForm').show();
      //  $('#shareCollectionConfirm').hide();
      //})
      //$('.create-collection-form').on('submit', Northstar.collections.createCollectionAjax);
    },

    viewMode: function(e) {
      e.preventDefault();
      $('.collections-results-wrapper').removeClass(function (index, className) {
        return (className.match (/(^|\s)view-\S+/g) || []).join(' ');
      });
      $('.collections-results-wrapper').addClass($(this).data('class'));
      $('.collections-util--viewmode a').removeClass('active');
      $(this).addClass('active');
    },

   // createCollectionAjax: function (e) {
      //e.preventDefault();
      //var form = this;

      //// Check if form validated first
      //if ($(form).attr('novalidate') === 'true') {
      //  Northstar.forms.validate(null, form);
      //  if (!$(form).data('valid')) {
      //    return false;
      //  }
      //}

      // TBD - ADD AJAX SUBMIT HERE
      // --------------------------
     // console.log('submitting via ajax with confirmation');
      // $.ajax({
      //   type: 'POST',
      //   url: '#',
      //   data: $(this).serialize(),
      //   success: function(response) {
      //     Northstar.collections.createCollectionSuccess(form);
      //   }
      // });
    //},

    createCollectionSuccess: function (form) {
      // Below code reveals the confirmation message for the ajax complete callback
      var emails = $('#share-to', form).val().split(',');
      $('#shareCollectionConfirm #sent-emails').empty().append(emails.join('<br>'));
      $('#shareCollectionForm').hide();
      $('#shareCollectionConfirm').fadeIn();
    }
  };

  // Initialize our app on document ready
  $(document).ready(Northstar.collections.attach);

}(jQuery, this, this.document));

function invokeSalarySurveyGate() {
    var url = window.location.pathname;
    $("#signupModal2").find("iframe").attr("src", "/user/widgets/register/?returl=" + escape(url));
    $(".gated-SalarySurvey-login").attr("href", "/User/Login/?returl=" + escape(url));
    $('#gatedSalarySurvey').modal('show');

}
function invokeEventVenuesGate() {
    var url = window.location.pathname;
    $("#signupModal2").find("iframe").attr("src", "/user/widgets/register/?returl=" + escape(url));
    $(".gated-EventVenue-login").attr("href", "/User/Login/?returl=" + escape(url));
    $('#gatedEventVenues').modal('show');
   
}
    function invokecolgate(id,typ) {
        if (id != "" &&  typ!="") {
            var url = window.location.pathname + "?gatetyp=col&itemid=" + id + "&itemtyp=" + typ;
            $("#signupModal2").find("iframe").attr("src", "/user/widgets/register/?returl=" + escape(url))
            $(".gated-collection-login").attr("href", "/User/Login/?returl=" + escape(url));
            $('#gatedcollection').modal('show');
        }
    }

    function invokeaddtocol(id, typ) {
        if (id != "" && typ != "") {
            $(".add-collection-item").attr("_itemid", id).attr("_itemtype", typ);
            $(".add-collection-note").val("");
            $(".add-collection-new-name").val("");
            var DTO = { 'colid':"" }


                DynaProxy.invoke("GetCollections", DTO, function (data) {
                    $(".addto-collection-list").html(data);
                    $('#addToCollectionModal').modal('show');
                }, AjaxFailed);

                $('#addToCollectionModal').modal('show');
            

            
        }
    }

    function invokedaddtoev() {
        $(".find-venue-hero-form").attr("_lg", 1);
    }

    function invokedaddtosv() {
        $("#gatedSalarySurvey").attr("_lg", 1);
    }

    function refreshcollist() {
        if ($(".collection-list").length == 0) { return;}
        var DTO = {'sort':$(".collection-sort-by").val()}
        $(".collection-list").css({ opacity: 0.3 });
            DynaProxy.invoke("GetCollectionList", DTO, function (data) {
                $(".collection-list").html(data);
                $(".collection-list").css({ opacity:'' });
            }, AjaxFailed);
    }
    $(function () {
        $(document).on("click", ".add-collection-item", function () {
            var sNewName = $(".add-collection-new-name").val();
            var sNote = $(".add-collection-note").val();
            var sSelectedCol = ""
            $(".addto-collection-list").find("*:checkbox:checked").map(function () { sSelectedCol+=$(this).val() + "," })

            if (sSelectedCol == "" && sNewName == "") {
                alert('Please select one or more collections or add a new to start a new collection')
                return false;
            }
            var id=$(this).attr("_itemid");
            var typ = $(this).attr("_itemtype");            
            var DTO = { 'itemid': id, 'itemtype':typ,'colId':sSelectedCol,'colName':sNewName,'note':sNote }
            DynaProxy.invoke("AddItemToCollection", DTO, function (data) { $('#addToCollectionModal').modal('hide') }, AjaxFailed);
            return false
        })
        $(document).on("click", ".add-to-collection", function () {
            var id = $(this).attr("_itemid");
            var typ = $(this).attr("_itemtype");
            invokeaddtocol(id,typ)
            
            return false;
        })

        $(document).on("click", ".gate-collection", function () {
            var id = $(this).attr("_itemid");
            var typ = $(this).attr("_itemtype");
            invokecolgate(id,typ)
            return false;
        })
        $(document).on("click", ".gated-collection-register", function () {
            $('#gatedcollection').on('hidden.bs.modal', function (e) { $('#signupModal2').modal('show'); })
            $('#gatedcollection').modal('hide');
            return false;
        })
        $(document).on("click", ".gated-EventVenue-register", function () {
            $('#gatedEventVenues').on('hidden.bs.modal', function (e) { $('#signupModal2').modal('show'); })
            $('#gatedEventVenues').modal('hide');
            return false;
        })

       $(document).on("click", ".gated-SalarySurvey-register", function () {
            $('#gatedSalarySurvey').on('hidden.bs.modal', function (e) { $('#signupModal2').modal('show'); })
            $('#gatedSalarySurvey').modal('hide');
            return false;
        })
        $(document).on("click", ".add-col-new-create", function () {
            var sName = $(".add-col-new-name").val();
            var sNote = $(".add-col-new-note").val();
            if (sName == "") {
                alert('Please fill out the new Collection Name')
                return false;
            }
            var DTO = { 'name': sName, 'note': sNote }
            DynaProxy.invoke("CreateCollection", DTO, function (data) {
                $(".add-col-new-name").val("")
                $(".add-col-new-note").val("")
                $('#createCollectionModal').modal('hide')
                refreshcollist();
            }, AjaxFailed);
            return false
        })
       
        
        $(document).on("click", ".add-col-edit-save", function () {
            var sName = $(".add-col-new-name").val();
            var sNote = $(".add-col-new-note").val();
            if (sName == "") {
                alert('Please fill out the new Collection Name')
                return false;
            }
            var DTO = { 'name': sName, 'note': sNote, 'colid': collectionid }
            DynaProxy.invoke("SaveCollection", DTO, function (data) {
                window.location.reload();
            }, AjaxFailed);
            return false
        })


        $(document).on("click", ".collection-delete", function () {
            if (confirm ("Are you sure you want to delete collection '" + $(this).parents(".col-root").find("h5 a").html() + "'?")){
                var id = $(this).parents(".col-root").attr("_id");         
                var DTO = { 'id': id,  }
                DynaProxy.invoke("DeleteCollection", DTO, function (data) {
                    refreshcollist();
                }, AjaxFailed);
            }
            return false
        })
        
        $(document).on("click", ".collection-filter", function () {
            $(".collection-filter").removeClass("active")
            $(this).addClass("active");
            var s = $(this).attr("val")
            if (s == "all") {
                $(".collections-items-table").find("tr").show()
            } else {
                $(".collections-items-table").find("tr").hide()
                $(".collections-items-table").find("tr[_ctype='" + s + "']").show()                
            }
            $(".col-header").show()

            return false;
        })

        $(document).on("click", ".collection-item-delete", function () {
            if (confirm("Are you sure you want to delete collection item '" + $(this).parents("tr").find(".collection-item-title").html() + "'?")) {
                var DTO = { 'itemid': $(this).parents("tr").attr("_id"), 'itemtype': $(this).parents("tr").attr("_type"), 'colid': collectionid }
                DynaProxy.invoke("RemoveItemFromCollection", DTO, function (data) {
                    window.location.reload();
                }, AjaxFailed);
            }
            return false;
        })

        $(document).on("click", ".col-item-set-cover", function () {
                var DTO = { 'url': $(this).attr("href"), 'colid': collectionid }
                DynaProxy.invoke("SetCollectionImage", DTO, function (data) {
                    window.location.reload();
                }, AjaxFailed);
             return false;
        })
        
        function showShare(sColName, colid) {
            $(".collection-sharing-title").html("Sharing: " + sColName)
            $(".collection-sharing-success").html(sColName + " shared successfully!")
            $(".collection-sharing-emails").html("");
            $(".collection-sharing-email").val("").attr("required", "true") //need to do this here to prevent premature validation
            $(".collection-sharing-subject").val($(".collection-sharing-subject").attr("placeholder")).attr("required", "true")
            $(".collection-sharing-message").val($(".page-title").html() + " has sent you a message!\n").attr("required", "true")
            $('#shareCollectionForm').show();
            $('#shareCollectionConfirm').hide();
            $(".collection-sharing-exec").attr("_colid",colid)
            $('#shareCollectionModal2').modal('show')

        }
        $(document).on("click", ".collection-share", function () {
            showShare($(".collection-name").html(), collectionid)
            return false;
        })

        $(document).on("click", ".collection-email", function () {
            showShare($(this).parents(".col-root").find("h5 a").html(),$(this).parents(".col-root").attr("_id"))
            return false;
        })

        $(document).on("click", ".edit-collection", function () {
            $("#editCollectionModal").modal('show')
            return false;
        })
                
        $(document).on("change", ".collection-sort-by", function () {
            refreshcollist();
        })
            $(document).on("click", ".collection-sharing-exec", function () {
            var form = $(".create-collection-form");

            // Check if form validated first
               Northstar.forms.validate(null, form);
                if (!$(form).data('valid')) {
                    return false;
                }
           
            var e=$(".collection-sharing-email").val()
            var s=$(".collection-sharing-subject").val()
            var m=$(".collection-sharing-message").val()

            var DTO = { 'e': e,'s':s,'m':m, 'colid': $(this).attr("_colid") }
               DynaProxy.invoke("ShareCollection", DTO, function (data) {
                   refreshcollist();
                   Northstar.collections.createCollectionSuccess(form)                   
               }, AjaxFailed);
             return false;
        })        
    
    });
